<template>
  <img
    src="/mw-mark.png"
    height="40"
    width="40"
    alt="MightyWELL"
  >
</template>

<script>
export default {
  name: 'ProjectLogo'
}
</script>
